function scrollElementIntoView(cssSelector) {
  const element = document.querySelector(cssSelector);
  element.scrollIntoView({
    behavior: 'smooth',
  });
}

export default scrollElementIntoView;
